// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Header_wrapper__1ZfjB","hideAdd":"Header_hideAdd__1bpAY"};